import React, { FC } from 'react';

import { YouCanComeBackNote } from '../../../../general/components/footers/you-can-come-back-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { FinancialStatementRequirements } from '../../components/financial-statement-requirements';

const JULY = 6;

const financialStatementYears = (): string => {
  const now = new Date();
  const year = now.getFullYear();

  return now.getMonth() >= JULY ? `${year} year to date, ${year - 1}, and ${year - 2}` : `${year - 1} and ${year - 2}`;
};

const FinancialStatementsPage: FC = () => (
  <WizardPage
    title="Upload your financial statements"
    subtext={
      <>
        We use these statements to better understand your business and <br />
        determine a credit line that’s high enough to support your spending.
      </>
    }
    footer={<YouCanComeBackNote />}
  >
    <FinancialStatementRequirements years={financialStatementYears()} />
  </WizardPage>
);

export { FinancialStatementsPage };
